'use strict';

var jsxRuntime = require('react/jsx-runtime');

const Idea = ({ disabled = false })=>{
    if (disabled) {
        return jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            "data-testid": "design-system-productIcon-icon-idea--disabled",
            children: [
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M39 41.917C39 40.3177 39.8836 38.8743 41.1427 37.8883C45.3192 34.6175 48 29.5496 48 23.8605C48 13.9964 39.9411 6 30 6C20.0589 6 12 13.9964 12 23.8605C12 29.5496 14.6808 34.6175 18.8573 37.8883C20.1164 38.8744 21 40.3177 21 41.917V49.5349C21 52.0009 22.9991 54 25.4651 54L34.5349 54C37.0009 54 39 52.0009 39 49.5349V41.917Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M21 43H39V49.5349C39 52.0009 37.0009 54 34.5349 54H25.4651C22.9991 54 21 52.0009 21 49.5349V43Z",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M29 48.7814C29.4316 48.7814 29.7814 48.4316 29.7814 48C29.7814 47.5684 29.4316 47.2186 29 47.2186V48.7814ZM21 48.7814H29V47.2186H21V48.7814Z",
                    fill: "#9E9E9E"
                }),
                jsxRuntime.jsx("path", {
                    d: "M32 43V27H28V43",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M22 23.7907C22 22.2494 23.2494 21 24.7907 21H25.2093C26.7506 21 28 22.2494 28 23.7907V27H24.7907C23.2494 27 22 25.7506 22 24.2093V23.7907Z",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M38 23.7907C38 22.2494 36.7506 21 35.2093 21H34.7907C33.2494 21 32 22.2494 32 23.7907V27H35.2093C36.7506 27 38 25.7506 38 24.2093V23.7907Z",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                })
            ]
        });
    }
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        "data-testid": "design-system-productIcon-icon-idea",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M39 41.917C39 40.3177 39.8836 38.8743 41.1427 37.8883C45.3192 34.6175 48 29.5496 48 23.8605C48 13.9964 39.9411 6 30 6C20.0589 6 12 13.9964 12 23.8605C12 29.5496 14.6808 34.6175 18.8573 37.8883C20.1164 38.8744 21 40.3177 21 41.917V49.5349C21 52.0009 22.9991 54 25.4651 54L34.5349 54C37.0009 54 39 52.0009 39 49.5349V41.917Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M21 43H39V49.5349C39 52.0009 37.0009 54 34.5349 54H25.4651C22.9991 54 21 52.0009 21 49.5349V43Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M29 48.7C29.3866 48.7 29.7 48.3866 29.7 48C29.7 47.6134 29.3866 47.3 29 47.3V48.7ZM21 48.7H29V47.3H21V48.7Z",
                fill: "#212121"
            }),
            jsxRuntime.jsx("path", {
                d: "M32 43V27H28V43",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M22 23.7907C22 22.2494 23.2494 21 24.7907 21H25.2093C26.7506 21 28 22.2494 28 23.7907V27H24.7907C23.2494 27 22 25.7506 22 24.2093V23.7907Z",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M38 23.7907C38 22.2494 36.7506 21 35.2093 21H34.7907C33.2494 21 32 22.2494 32 23.7907V27H35.2093C36.7506 27 38 25.7506 38 24.2093V23.7907Z",
                stroke: "#212121",
                strokeWidth: "1.4"
            })
        ]
    });
};

module.exports = Idea;
